import { bulkUpdateDraftPosts } from '@wix/ambassador-blog-v3-draft/http';
import { Action, Field } from '@wix/ambassador-blog-v3-draft/types';
import _, { chunk as getChunks } from 'lodash';
import { fetchBlogPosts } from '../new-infra-fetchers/fetch-blog-posts';
import { buildPostsBulkUpdatePayload } from './build-payloads/bulk-update-blog-posts-alt-text-payload-builder';
const BULK_LIMIT = 20;
const convertToDraftPostForUpdate = post => {
  return {
    id: post.id,
    richContent: post.richContent
  };
};
export const updateBlogPostsAltText = async (httpClient, errorHandler, altTextData, isExperimentEnabled) => {
  const {
    withErrorHandler,
    getResolvedError
  } = errorHandler;
  const entityIdsList = altTextData.map(item => item.entityId).filter(entityId => entityId !== undefined);
  try {
    const blogPosts = await fetchBlogPosts(httpClient, errorHandler, entityIdsList, isExperimentEnabled);
    const shouldConvert = isExperimentEnabled == null ? void 0 : isExperimentEnabled('specs.seo-data-service.splitDraftAndPostQuery');
    const postsForUpdate = shouldConvert ? blogPosts.map(convertToDraftPostForUpdate) : blogPosts;
    const convertedPostsMap = new Map(postsForUpdate.map(post => [post.id, post]));
    const altTextDataByEntityId = _.groupBy(altTextData, item => item.entityId);
    const allFailedElements = [];
    const payloadEntity = Object.values(altTextDataByEntityId).map(items => {
      const payload = buildPostsBulkUpdatePayload(items, convertedPostsMap);
      return {
        items,
        payload
      };
    }).flat();
    const chunks = getChunks(payloadEntity, BULK_LIMIT);
    const updatePromises = chunks.map(async chunk => {
      var _data$bulkActionMetad;
      const payloadChunk = chunk.map(_ref => {
        let {
          payload
        } = _ref;
        return payload;
      }).flat();
      const itemsChunk = chunk.map(_ref2 => {
        let {
          items
        } = _ref2;
        return items;
      }).flat();
      if (payloadChunk.length === 0) {
        return {
          failedElements: itemsChunk,
          success: false
        };
      }
      const {
        data
      } = await withErrorHandler(async () => httpClient.request(bulkUpdateDraftPosts({
        action: Action.UPDATE,
        draftPosts: payloadChunk,
        fieldsets: [Field.RICH_CONTENT]
      })), {
        errorCodesMap: {}
      });
      const success = ((_data$bulkActionMetad = data.bulkActionMetadata) == null ? void 0 : _data$bulkActionMetad.totalFailures) === 0;
      if (!success) {
        const failedElementsChunk = itemsChunk.filter((_item, index) => {
          var _data$results;
          return !((_data$results = data.results) != null && (_data$results = _data$results[index]) != null && (_data$results = _data$results.itemMetadata) != null && _data$results.success);
        });
        allFailedElements.push(...failedElementsChunk);
      }
      return {
        success
      };
    });
    const settledResults = await Promise.allSettled(updatePromises);
    const results = settledResults.map(result => {
      if (result.status === 'fulfilled') {
        return result.value;
      } else {
        return {
          success: false
        };
      }
    });
    const overallSuccess = results.every(result => result.success);
    return {
      failedElements: allFailedElements,
      success: overallSuccess
    };
  } catch (error) {
    return {
      errorMessage: getResolvedError(error).message,
      failedElements: altTextData,
      success: false
    };
  }
};
//# sourceMappingURL=update-blog-posts-alt-text.js.map